import { athlete } from "@/data/athlete";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-zinc-900 py-10 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
          <div className="font-display text-xl text-white uppercase tracking-tight">
            {athlete.firstName} {athlete.lastName}{" "}
            <span className="text-[#FF3B30]">/ #{athlete.jerseyNumber}</span>
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 font-bold mt-1">
            {athlete.position} · Class of {athlete.gradYear}
          </div>
        </div>
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-600 font-semibold">
          © {new Date().getFullYear()} — Recruiting Profile
        </div>
      </div>
    </footer>
  );
};
